export default __webpack_public_path__ + "static/media/flash.617fb329.svg";